import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Replaces React Native's <ActivityIndicator/>. Same role: a centred busy state. */
export function Spinner({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <Loader2
      className={cn('animate-spin text-muted-foreground', className)}
      size={size}
      aria-label="Loading"
      role="status"
    />
  )
}

export function FullPageSpinner({ color }: { color?: string }) {
  return (
    <div className="flex h-full min-h-screen w-full items-center justify-center bg-muted/40">
      <Loader2 className="animate-spin" size={32} style={color ? { color } : undefined} aria-label="Loading" role="status" />
    </div>
  )
}
